import { TFunction } from 'i18next';

import UnknownImage from '../assets/images/unknown.png';
import { ETL_INTEGRATION_TYPE, SUPPORTED_INTEGRATIONS, Values } from '../components/configuration/types';

export interface IntegrationLogoAttributes {
  image: string;
  alt: string;
  className: string;
}

export const getIntegrationLogoAttributes = async (
  integration: Values<typeof ETL_INTEGRATION_TYPE>,
  t: TFunction
): Promise<IntegrationLogoAttributes> => {
  const integrationLowerCased = integration.toLowerCase();

  const isIntegrationPresent = (SUPPORTED_INTEGRATIONS as readonly string[]).includes(integrationLowerCased);
  const unknownIntegrationLogoAttributes = {
    alt: t(`providers.${ETL_INTEGRATION_TYPE.unknown}`),
    className: 'configuration-card__image',
    image: UnknownImage,
  };

  if (!isIntegrationPresent) {
    return unknownIntegrationLogoAttributes;
  }

  try {
    const importedImage = await import(`../assets/images/${integrationLowerCased}.png`);
    return {
      alt: t(`providers.${integrationLowerCased}`),
      className: 'configuration-card__image',
      image: importedImage.default,
    };
  } catch (_) {
    console.warn(
      `[getIntegrationLogoAttributes]: failed to import integration logo for "${integrationLowerCased}" integration.`
    );
    return unknownIntegrationLogoAttributes;
  }
};
